import { render } from "./ForecastResultsTable.vue?vue&type=template&id=456c7f34&scoped=true"
import script from "./ForecastResultsTable.vue?vue&type=script&lang=js"
export * from "./ForecastResultsTable.vue?vue&type=script&lang=js"

import "./ForecastResultsTable.vue?vue&type=style&index=0&id=456c7f34&scoped=true&lang=css"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456c7f34"]])

export default __exports__